import { render } from "./BookmarkIcon.vue?vue&type=template&id=e33ecc9a"
const script = {}
script.render = render

export default script